import React from 'react';
import * as S from '../ListingSection/listing-section.styles';

const ResetAllFilters = ({ removeAllFilters }) => {
  return (
    <S.ListingOuter className="errorState dF flexCol justifyCenter alignItemsCenter">
      <p className="marginB20">
        <img src={'https://gos3.ibcdn.com/emptyState-1656584030.png'} width="188" height="83" />
      </p>
      <div className="fb quicksand font14 marginB10">
        There are no destinations with the applied filters or for those dates.
      </div>
      <div className="font12 marginB20">
        Please remove the filters or change the dates an try again.
      </div>
      <div className="viewAllfliBtn curPointFlt" onClick={removeAllFilters}>
        REMOVE ALL FILTERS
      </div>
    </S.ListingOuter>
  );
};
export default ResetAllFilters;
